import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  ActionStatus,
  MutationDemoteChatAdminsArgs,
} from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getChatParticipantsKey } from '../../utils/keys/messaging.key.js'

export const useDemoteChatAdmins = (
  options?: UseMutationOptions<
    ActionStatus,
    ClientError,
    MutationDemoteChatAdminsArgs
  >,
) => {
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<ActionStatus, ClientError, MutationDemoteChatAdminsArgs>(
    (input: MutationDemoteChatAdminsArgs) =>
      client.messaging.demoteChatAdmins(input),
    {
      ...(options ?? {}),
      onSuccess: (data, variables, context) => {
        const chatParticipantsKey = getChatParticipantsKey({
          variables: {
            chatId: variables.chatId,
          },
        })

        queryClient.invalidateQueries(chatParticipantsKey)
        options?.onSuccess?.(data, variables, context)
      },
    },
  )
}
